export const COMMUNICATION_SYSTEM = {
  STATUS: {
    EVENT_RECORDER_ERROR: 0,
    BCU_ERROR: 0,
    TCU_ERROR: 0,
    WTB_MVB_ERROR: 0,
    CCU_ERROR: 0,
    HMI_OK: 1,
    HMI_NOK: 0,
    ACTIVE_CCU: 1,
    MVB_RIOM_1_ERROR: 3,
    MVB_RIOM_2_ERROR: 3,
    MVB_RIOM_3_ERROR: 3,
    MVB_RIOM_4_ERROR: 3,
    CAN_RIOM_ERROR: 1,
    PAPIS_ERROR: 1,
    CCTV_ERROR: 1
  }
} as const;
